// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__33MF6","rootSuccess":"CompleteLink_rootSuccess__2lJkT","rootFailure":"CompleteLink_rootFailure__ZPaae","isDisabled":"CompleteLink_isDisabled__x7oY0"};